module.exports = __webpack_public_path__ + "img/1.1.51d844d4.jpg";